// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsPopup_menu__kft_b","menuItem":"ActionsPopup_menuItem__35LQU"};